import React from "react";
import { useStore } from "../../store/store";
import { SelectChangeEvent } from "@mui/material";
import fractionToInt from "../../util/fractionToInt";

interface UpdateObj {
  jamb: string;
  addScreen: string;
  screenPocket: string;
  screenColor: string;
  unitSize?: string;
  cornerWidthRight?: string;
}

function useWidthSelection() {
  const addToQuote = useStore((state) => state.addToQuote);

  const cornerType = useStore((state) => state.quote.cornerType);
  const leftWidth = useStore((state) => state.quote.unitSize);
  const leftFraction = useStore((state) => state.quote.unitSizeFraction);

  const rightWidth = useStore((state) => state.quote.cornerWidthRight);
  const rightFraction = useStore(
    (state) => state.quote.cornerWidthFractionRight
  );

  const handleError = useStore((state) => state.handleError);

  const errors = useStore((state) => state.errors);

  const showError = (overall: number, key: string) => {
    let err = "";

    const max = 286.625;
    const min = 34.375;

    const errMsgHigh = "Width can not exceed";
    const errMsgLow = "Width must exceed";

    if (overall > max) {
      err = `${errMsgHigh} 286 5/8"`;
    } else if (overall < min) {
      err = `${errMsgLow} 34 3/8"`;
    }

    return handleError(key, err);
  };

  const handleWidthChangeLeft = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    const num = parseInt(value);

    let update: UpdateObj = {
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
    };

    if (!num) update["unitSize"] = "";
    else update["unitSize"] = `${num}`;

    addToQuote(update, "unitSize");

    if (num) {
      const overallLeft = fractionToInt(value, leftFraction);
      showError(overallLeft, "widthErr");
    }
  };

  const handleWidthChangeRight = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    const num = parseInt(value);

    let update: UpdateObj = {
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
    };

    if (!num) update["cornerWidthRight"] = "";
    else update["cornerWidthRight"] = `${num}`;

    addToQuote(update, "cornerWidthRight");

    if (num) {
      const overallRight = fractionToInt(value, rightFraction);
      showError(overallRight, "widthErrCornerRight");
    }
  };

  const handleFractionChangeLeft = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value === null) return addToQuote({ unitSizeFraction: "" });

    addToQuote({
      unitSizeFraction: value,
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
    });

    const overallLeft = fractionToInt(leftWidth, value);
    showError(overallLeft, "widthErr");
  };

  const handleFractionChangeRight = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value === null) return addToQuote({ cornerWidthFractionRight: "" });

    addToQuote({
      cornerWidthFractionRight: value,
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
    });

    const overallRight = fractionToInt(rightWidth || "", value);
    showError(overallRight, "widthErrCornerRight");
  };

  return {
    handleWidthChangeLeft,
    handleFractionChangeLeft,
    handleFractionChangeRight,
    handleWidthChangeRight,
    widthErrCornerRight: errors.widthErrCornerRight,
    widthErr: errors.widthErr,
    cornerType,
    leftWidth,
    rightWidth,
    leftFraction,
    rightFraction,
  };
}

export default useWidthSelection;
